import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

type DayProps = {
  filled?: boolean;
  outlined?: boolean;
  highlighted?: boolean;
  disabled?: boolean;
  startOfRange?: boolean;
  endOfRange?: boolean;
  onClick?: () => void;
  onHover?: () => void;
  value: number | string;
};

const stylesBuilder = () => ({
  leftBorderRadius: {
    borderRadius: '50% 0 0 50%'
  },
  rightBorderRadius: {
    borderRadius: '0 50% 50% 0'
  },
  buttonContainer: {
    display: 'flex'
  },
  button: {
    height: '36px',
    width: '36px',
    padding: 0
  },
  buttonText: {
    lineHeight: 1.6
  },
  outlined: {
    border: `1px solid #FF6320`
  },
  filled: {
    '&:hover': {
      backgroundColor: 'rgba(62, 145, 242, 0.58)'
    },
    backgroundColor: '#1970D6'
  },
  highlighted: {
    backgroundColor: 'rgba(62, 145, 242, 0.58)'
  },
  contrast: {
    color: 'white'
  }
});

function Day(props: DayProps) {
  const styles = stylesBuilder();
  return (
    <Box
      sx={{
        ...styles?.buttonContainer,
        ...(props.startOfRange ? styles?.leftBorderRadius : {}),
        ...(props.endOfRange ? styles?.rightBorderRadius : {}),
        ...(!props.disabled && props.highlighted ? styles?.highlighted : {})
      }}
    >
      <IconButton
        disabled={props.disabled}
        onClick={props.onClick}
        onMouseOver={props.onHover}
        sx={{
          ...styles?.button,
          ...(!props.disabled && props.outlined ? styles?.outlined : {}),
          ...(!props.disabled && props.filled ? styles?.filled : {})
        }}
      >
        <Typography
          color={!props.disabled ? 'initial' : 'textSecondary'}
          sx={{
            ...styles?.buttonText,
            ...(!props.disabled && props.filled ? styles?.contrast : {})
          }}
          variant="body2"
        >
          {props.value}
        </Typography>
      </IconButton>
    </Box>
  );
}

export default Day;
